"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItemComponent = void 0;
var react_1 = __importDefault(require("react"));
var RenderListGroup_1 = require("../RenderTokensHost/RenderList/RenderListGroup");
var RenderTokensHostContext_1 = require("../RenderTokensHost/RenderTokensHostContext");
var classnames_1 = __importDefault(require("classnames"));
var styles = __importStar(require("@CommonFrontend/ContentTokens/SharedWidgetComponents/Text/ListItem.css"));
var List_1 = require("../Models/List");
var SiblingTokensContext_1 = require("../RenderTokensHost/SiblingTokensContext");
var ListItemShared_1 = require("./ListItemShared");
var textStyles_1 = require("@CommonFrontend/WidgetRegistry/Traits/Styleable/textStyles");
var ListItemComponent = function (_a) {
    var token = _a.token, style = _a.style, suppliedAttributes = _a.attributes, childTokens = _a.childTokens;
    var nestedLists = (0, RenderListGroup_1.useRenderListItemContext)().nestedLists;
    var RenderTokensHost = (0, RenderTokensHostContext_1.useRenderTokensHostContext)().RenderTokensHost;
    var computeForegroundColor = undefined;
    var sharedStyles = __assign(__assign({}, (0, textStyles_1.maybeAssignComputedForegroundColor)({
        computeForegroundColor: computeForegroundColor,
        foregroundColorVar: styles.listItemSharedVars.color,
        foregroundStyle: style,
    })), (0, textStyles_1.maybeAssignComputedForegroundColor)({
        computeForegroundColor: computeForegroundColor,
        foregroundColorVar: styles.listItemSharedVars.markerColor,
        foregroundStyle: { color: style.markerColor },
    }));
    var attributes = makeAttributes(token, suppliedAttributes, style, sharedStyles);
    return (react_1.default.createElement("li", __assign({}, attributes),
        token.listType === List_1.ListItemType.Number && react_1.default.createElement(OrderedBeforeNumber, { token: token }),
        react_1.default.createElement("span", null,
            react_1.default.createElement(RenderTokensHost, { tokens: childTokens })),
        nestedLists));
};
exports.ListItemComponent = ListItemComponent;
var OrderedBeforeNumber = function (_a) {
    var token = _a.token;
    var siblings = (0, SiblingTokensContext_1.useSiblingTokensContext)().siblings;
    var listItemNumber = token.startCounter || 1;
    var itemIndex = siblings.indexOf(token);
    if (itemIndex === -1) {
        throw new Error("List item token not found in siblings");
    }
    for (var i = itemIndex - 1; i >= 0; i--) {
        var sibling = siblings[i];
        if (!sibling) {
            continue;
        }
        if (sibling.type === "block") {
            if (sibling.subType == "listItem" && sibling["listType"] == "number" && sibling["level"] == token.level) {
                if (sibling["startCounter"] != null) {
                    listItemNumber += sibling["startCounter"];
                }
                else {
                    listItemNumber++;
                }
            }
            if (sibling.subType != "listItem" || sibling["listType"] != "number" || sibling["level"] < token.level) {
                break;
            }
        }
    }
    var displayNumber = (0, ListItemShared_1.getDisplayNumber)(listItemNumber, token.level);
    return react_1.default.createElement("span", { className: "before" }, displayNumber);
};
var makeAttributes = function (token, suppliedAttributes, style, sharedStyles) {
    if (token.listType === List_1.ListItemType.Number) {
        return {
            className: (0, classnames_1.default)("ordered", styles.listItem({ listType: "ordered" }), suppliedAttributes.className),
            style: __assign(__assign({}, suppliedAttributes.style), sharedStyles),
        };
    }
    else {
        return {
            className: (0, classnames_1.default)("unordered", "level-".concat(token.level), suppliedAttributes.className, styles.listItem({
                listType: "unordered",
                level: token.level % 2 === 0 ? "even" : "odd",
                markerStyle: style.marker,
            })),
            style: __assign(__assign({}, suppliedAttributes.style), sharedStyles),
        };
    }
};
